import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import FormSectionTitle from '@src/components/Form/FormSectionTitle'
import { useTabs, ASSSTabs, getTabsByType } from '@src/components/Tabs/useTabs'
import TabsComp, { Tab } from '@src/components/Tabs/Tabs'
import { ProjectTypeId } from '@src/types/ProjectTypeId'
import TabsWrapper from '@src/modules/SiteResoureRequirements/comps/TabsWrapper'
import { useDRS } from '../../useDRS'
import CompDRSReworkSummary from './parts/ReworkSummary'
import CompDRSReworkAssets from './parts/ReworkAssets'

interface Props {

}

const DRSRework = (props: Props) => {
  const {

  } = props
  const [ tabIndex, tabs, handleTabChange, setTabs ] = useTabs(ASSSTabs)
  const { drs } = useDRS()
  useEffect(() => {
    if (drs !== null) {
      setTabs(getTabsByType(drs.jobDetails.drsProjectType.id))
    }
  }, [drs])
  
  const renderAsOrSS = () => {
    const currentTab: Tab = tabs[tabIndex]
    if (currentTab.key === ProjectTypeId.Asphalt) {
      return <React.Fragment>
        <CompDRSReworkSummary projectTypeId={ProjectTypeId.Asphalt}/>
        <CompDRSReworkAssets projectTypeId={ProjectTypeId.Asphalt}/>
      </React.Fragment>
    } else {
      return <React.Fragment>
        <CompDRSReworkSummary projectTypeId={ProjectTypeId.SpraySeal}/>
        <CompDRSReworkAssets projectTypeId={ProjectTypeId.SpraySeal}/>
      </React.Fragment>
    }
  }

  return <Wrapper>
    <FormSectionTitle>Rework</FormSectionTitle>
    <TabsWrapper>
      <TabsComp 
        tabs={tabs} 
        activeIndex={tabIndex}
        onChange={handleTabChange}
      />
    </TabsWrapper>
    { renderAsOrSS() }
  </Wrapper>
}

const Wrapper = styled.div`

`
export default DRSRework